
import { IJuridicoCobrancaJudicial } from '@/interfaces/juridico';
import { juridicoStore, mainStore } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class CreateCobrancaJudicial extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly propTitulos;
  //   @Prop({ type: Number }) readonly propId;
  @Prop({ type: String }) readonly propTitle;
  @Prop({ type: Number }) readonly propC014_id_unidade;
  @Prop({ type: String }) readonly propTitleBtn;
  @Prop({ type: String }) readonly propTipo;
  @Prop({ type: String }) readonly propTituloAlert;
  @Prop({ type: Number, default: 0 }) readonly propState;

  public isLoading = false;
  public isLoadingSubmit = false;

  public companyItems = [];
  public tipoSolicitacoes = [];
  public tipoAux = 0;
  public statusAux = 0;
  public clicouSalvar = false;
  public created_by_id = 0;
  public created_by_name = '';
  public franchising_id = 0;

  public c014ItemsPessoa = 0;
  public titulo = '';

  public descricao = '';
  public tipoSolicitacao = '';

  public headersFinanceiro = [
    {
      text: 'Nº Título',
      sortable: true,
      value: 'Documento',
      align: 'left',
    },
    {
      text: 'Vencimento',
      sortable: true,
      value: 'T014_Vencimento',
      align: 'left',
    },
    // {
    //   text: "Data pagamento",
    //   sortable: true,
    //   value: "T014_DataPagamento",
    //   align: "left",
    // },
    {
      text: 'Nome / Razão Social',
      sortable: true,
      value: 'NomeRazaoSocial',
      align: 'left',
    },
    {
      text: 'Tipo / Documento',
      sortable: true,
      value: 'TipoPessoa',
      align: 'left',
    },
    {
      text: 'Tipo',
      sortable: true,
      value: 'Tipo',
      align: 'left',
    },
    {
      text: 'Filial',
      sortable: true,
      value: 'Filial',
      align: 'left',
    },
    {
      text: 'Valor original',
      sortable: true,
      value: 'valor_original',
      align: 'left',
    },
    {
      text: 'Valor atualizado',
      sortable: true,
      value: 'valor_atualizado',
      align: 'left',
    },
    {
      text: 'Dias Atraso',
      sortable: true,
      value: 'Atraso',
      align: 'center',
    },
  ];
  get currentUser() {
    return mainStore.userProfile;
  }

  get allItemsUnidades() {
    let item = this.companyItems[1];
    return item;
  }
  public titleCase(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  public async handleSubmitTitulos() {
    this.$swal({
      title: 'Confirma solicitação de envio dos títulos para o ' + this.propTituloAlert + '?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoadingSubmit = true;
        this.clicouSalvar = true;

        let res: any = [];

        let serasa = '';
        let cobranca = '';
        if (this.propTipo === 'S') {
          serasa = 'S';
        } else {
          cobranca = 'S';
        }

        // Grava os títulos na tabela juridico_cobranca_judicial
        this.propTitulos.forEach(async (item) => {
          let cobranca_judicial: IJuridicoCobrancaJudicial = {
            c014_id: this.propC014_id_unidade,
            c014_id_titulo: item.c014_id,
            devedor_nome: item.NomeRazaoSocial,
            devedor_tipo: item.TipoPessoa,
            devedor_doc: item.DocPessoa,
            titulo: item.Documento,
            filial: item.Filial,
            vencimento: item.T014_Vencimento,
            tipo_divida: item.Tipo,
            valor_original: item.valor_original,
            valor_atualizado: item.valor_atualizado,
            dias_atraso: item.Atraso,
            T014_Id_Parcela: item.T014_Id_Parcela,
            observacao: item.Observação,
            status_serasa: serasa,
            status_judicial: cobranca,
            status_titulo: 'Envio solicitado',
            created_by_id: this.currentUser.id,
          };

          res = await juridicoStore.createJuridicoCobrancaJudicial(cobranca_judicial);
        });

        if (res) {
          this.$swal.fire('Solicitação de envio para o ' + this.propTituloAlert, 'Salvo com sucesso!', 'success');
          let response = setTimeout(async () => {
            this.$emit('getPropState', Math.floor(Math.random() * 200));
          }, 1000);
        } else {
          this.$swal.fire('Falha ao salvar o envio.', 'Tente novamente mais tarde!', 'error');
        }
      }

      this.isLoadingSubmit = false;
    });
  }

  public async mounted() {
    this.isLoading = true;
    this.clicouSalvar = false;
    this.isLoading = false;
  }
}
